import { render, staticRenderFns } from "./add_tag_form.vue?vue&type=template&id=6342bf4a&scoped=true&"
import script from "./add_tag_form.vue?vue&type=script&lang=js&"
export * from "./add_tag_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6342bf4a",
  null
  
)

export default component.exports